import { FTLPhoneUtils, requiredMessage, } from "ftl-core";
import * as Yup from "yup";
export const normalizePhoneRegexp = /[-()_\s+]/gm;
export const ProfileSchema = (phoneFormat) => {
    var _a;
    const regex = FTLPhoneUtils.regExpConstructor(phoneFormat);
    return Yup.object({
        firstName: Yup.string().required(requiredMessage),
        lastName: Yup.string().required(requiredMessage),
        phoneNumber: Yup.string()
            .transform((value) => value.replaceAll(normalizePhoneRegexp, ""))
            .matches(regex, FTLPhoneUtils.matchConstructor(phoneFormat))
            .min((_a = phoneFormat === null || phoneFormat === void 0 ? void 0 : phoneFormat.mask.replaceAll(normalizePhoneRegexp, "").length) !== null && _a !== void 0 ? _a : 0, "Номер слишком короткий"),
    });
};
//# sourceMappingURL=model.js.map